// @flow
import { authenticatedFetch } from '../../../api/request';

export default async function setNotificationsAsRead(ids: Array<number>) {
    const url = '/v5/notifications/read';
    const payload = {
        notificationIds: ids.join()
    };
    return await authenticatedFetch(url, {
        method: 'PUT',
        body: JSON.stringify(payload)
    });
}
